/* UI-Texte je Locale (2026-09-16): document.documentElement.lang, com de/en/fr/es, ch de-CH/en-CH/fr-CH; unbekannt -> de. */
var zsText = (function () {
  var lang = String(document.documentElement.lang || 'de').slice(0, 2).toLowerCase();
  var T = {
    de: { description: 'Beschreibung', details: 'Details', faq: 'Häufige Fragen', subscription: 'Abo -10%', more: 'Mehr anzeigen', less: 'Weniger anzeigen', gift: 'Geschenk', closeImage: 'Bild schliessen' },
    en: { description: 'Description', details: 'Details', faq: 'Frequently asked questions', subscription: 'Subscription -10%', more: 'Show more', less: 'Show less', gift: 'Gift', closeImage: 'Close image' },
    fr: { description: 'Description', details: 'Détails', faq: 'Questions fréquentes', subscription: 'Abonnement -10%', more: 'Afficher plus', less: 'Afficher moins', gift: 'Cadeau', closeImage: "Fermer l'image" },
    es: { description: 'Descripción', details: 'Detalles', faq: 'Preguntas frecuentes', subscription: 'Suscripción -10%', more: 'Mostrar más', less: 'Mostrar menos', gift: 'Regalo', closeImage: 'Cerrar imagen' }
  };
  return function (k) { return (T[lang] || T.de)[k] || T.de[k]; };
})();
/* Geldbetrag im Storefront-Format (2026-10-08): ohne Format gilt shopMoneyFormat aus header.liquid (Marktwaehrung); dessen {{amount}} (CHF) mit Punkt-Dezimal wie Liquid.
   Ersetzt Shopify.formatMoney, damit auch formatlose Aufrufe in assets.js (Drawer-Summen) die Marktwaehrung tragen. */
var zsGeld = (function (basis) {
  function geld(cents, format) {
    var f = format || window.shopMoneyFormat, amount = /\{\{\s*amount\s*\}\}/;
    if (f && f === window.shopMoneyFormat && amount.test(f)) return f.replace(amount, (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','));
    return basis.call(window.Shopify, cents, f);
  }
  geld.basis = basis;
  return geld;
})(window.Shopify && window.Shopify.formatMoney && (window.Shopify.formatMoney.basis || window.Shopify.formatMoney));
if (window.Shopify && typeof Shopify.formatMoney === 'function') Shopify.formatMoney = zsGeld;
window.addEventListener('load', function () {
    let fiveMinutes = 60 * 15,
        display = document.querySelector('#count-down-timer');
    if (display) {
      startTimer(fiveMinutes, display);
    }
    
});

function startTimer(duration, display) {
    let timer = duration, minutes, seconds;
    let interval = setInterval(function () {
        minutes = parseInt(timer / 60, 10)
        seconds = parseInt(timer % 60, 10);

        minutes = minutes < 10 ? "0" + minutes : minutes;
        seconds = seconds < 10 ? "0" + seconds : seconds;

        display.textContent = minutes + ":" + seconds;

        
        if (--timer < 0) {
            clearInterval(interval);
        }
    }, 1000);
}
/* QB-Stufen-Buttons → Theme-Drawer statt /cart-Vollseite */
(function () {
  var TIER_QTY = [2, 4, 6];                  // Reihenfolge deiner Stufen-Buttons
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.omg-groupsTable .omg-table-atc-add');
    if (!btn) return;
    var form = btn.closest('form.product-form') || document.querySelector('form.product-form');
    var idInput = form && form.querySelector('[name="id"]:not([disabled])');
    if (!idInput) return;                     // kein Formular → App-Standard lassen
    e.preventDefault(); e.stopImmediatePropagation();   // App-Weiterleitung zur /cart-Seite blocken
    var row = btn.closest('tr');
    var btns = row ? [].slice.call(row.querySelectorAll('.omg-table-atc-add')) : [btn];
    var qty = TIER_QTY[btns.indexOf(btn)] || 1;
    var fd = new FormData(form);
    fd.set('quantity', qty);
    fetch('/cart/add.js', { method:'POST', body: fd, credentials:'same-origin' })
      .then(function (r) { if (!r.ok) throw 0;
        document.cookie = 'show_cart=true; path=/; max-age=60';   // Theme-Cookie
        window.location.reload(); })                              // → #sliding-cart.active
      .catch(function () { window.location = '/cart'; });         // Notfall: altes Verhalten
  }, true);
})();
/* Sticky-CTA: Abo-Preis + "Abo -10%"-Pille + selling_plan (nur Zahl, kein Streichpreis) */
(function () {
  var PILL_TEXT = zsText('subscription');
  function init() {
    var mainForm = [].slice.call(document.querySelectorAll('form.product-form'))
      .find(function (f) { return !f.closest('.sticky-cart__form'); });
    var stickyForm = document.querySelector('.sticky-cart__form form');
    var priceBox = document.getElementById('price');
    var slots = [].slice.call(document.querySelectorAll('[id^="price-"][id$="--alt"], .sticky-mobile-price'));
    if (!mainForm || !priceBox || !slots.length) return;

    function currentPrice() {
      var b = priceBox.querySelector('.current-price b');
      var m = b ? b.innerText.match(/CHF\s*[\d.,]+|[\d.,]+\s*(€|CHF)/) : null;
      return m ? m[0].replace(/\s+/g, ' ').trim() : '';
    }
    function plan() {
      var sp = mainForm.querySelector('[name="selling_plan"]:not([data-mirror]):not([disabled])');
      return sp && sp.value ? sp.value : '';
    }
    function pill(slot) {
      var p = slot.querySelector('.abo-pill');
      if (!p) {
        p = document.createElement('span');
        p.className = 'abo-pill';
        p.textContent = PILL_TEXT;
        p.style.cssText = 'display:none;margin-left:8px;background:#c492b2;color:#fff;font-size:11px;font-weight:500;padding:2px 8px;border-radius:99px;white-space:nowrap;vertical-align:middle;';
        slot.appendChild(p);
      }
      return p;
    }
    function sync() {
      var isAbo = !!plan(), amount = currentPrice();
      slots.forEach(function (slot) {
        slot.querySelectorAll('.price-item--regular, .price-item--sale').forEach(function (el) {
          if (amount) el.textContent = ' ' + amount + ' ';
        });
        pill(slot).style.display = isAbo ? 'inline-block' : 'none';
      });
      if (stickyForm) {
        var hid = stickyForm.querySelector('input[name="selling_plan"][data-mirror]');
        if (isAbo) {
          if (!hid) { hid = document.createElement('input'); hid.type = 'hidden'; hid.name = 'selling_plan'; hid.setAttribute('data-mirror', '1'); stickyForm.appendChild(hid); }
          hid.value = plan();
        } else if (hid) { hid.value = ''; }
      }
    }
    new MutationObserver(sync).observe(priceBox, { subtree: true, childList: true, characterData: true, attributes: true });
    document.addEventListener('click', function (e) { if (e.target.closest('.sealsubs-target-element, [name="selling_plan"]')) setTimeout(sync, 60); });
    document.addEventListener('change', function (e) { if (e.target && (e.target.name === 'selling_plan' || e.target.name === 'id')) sync(); });
    sync(); setTimeout(sync, 600); setTimeout(sync, 1600);
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();
jQuery(function ($) {
  $(window).off('scroll');
  function zsHeader() {
    var $leisten = $('#fade-it-on-scroll, #header-recommendation');
    var gescrollt = $(window).scrollTop() >= 50;
    $('header, #SBTrustedShopsMobile').toggleClass('scrolled', gescrollt);
    if (!window.matchMedia('(max-width: 1024px)').matches) {
      $leisten.stop(true, false).show();
      return;
    }
    if (gescrollt) $leisten.slideUp(550);
    else $leisten.slideDown(550);
  }
  $(window).on('scroll resize', zsHeader);
  zsHeader();
});
/* PDP Mobile-Kaufzone, 2026-08-05. Braucht die zugehoerigen Styles in custom.css. */

(function () {
  var gal = document.querySelector('.product-gallery');
  if (!gal) return;

  /* --- M5: Galerie-Zähler ----------------------------------
     Slick baut .slick-list erst bei seiner Initialisierung, die
     nach custom.js laufen kann. Deshalb bis zu 5s auf die
     Struktur warten statt einmalig zu prüfen. */
  (function () {
    var tries = 0;
    (function starte() {
      var host = gal.querySelector('.slick-list');
      if (!host) {
        if (++tries < 25) setTimeout(starte, 200);
        return;
      }
      if (document.getElementById('zs-galcount')) return;
      var gesamt = gal.querySelectorAll('.slick-slide:not(.slick-cloned)').length;
      if (gesamt < 2) return;

      if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
      var zaehler = document.createElement('div');
      zaehler.id = 'zs-galcount';
      host.appendChild(zaehler);

      function setze() {
        var akt = gal.querySelector('.slick-current');
        var idx = akt ? parseInt(akt.getAttribute('data-slick-index'), 10) + 1 : 1;
        zaehler.textContent = (idx > 0 ? idx : 1) + ' / ' + gesamt;
      }
      setze();
      if (window.jQuery) {
        var slider = gal.querySelector('.slick-slider');
        if (slider) jQuery(slider).on('afterChange', setze);
      }
    })();
  })();

  /* --- M7: Bildzoom per nativem dialog ---------------------- */
  (function () {
    if (typeof HTMLDialogElement === 'undefined') return;
    if (document.getElementById('zs-zoom-dlg')) return;

    var dlg = document.createElement('dialog');
    dlg.id = 'zs-zoom-dlg';
    dlg.innerHTML = '<button id="zs-zoom-close" type="button" aria-label="' + zsText('closeImage') + '">&times;</button><img alt="">';
    document.body.appendChild(dlg);
    var gross = dlg.querySelector('img');

    gal.addEventListener('click', function (e) {
      var img = e.target.closest('img');
      if (!img) return;
      if (!img.closest('.slick-slide')) return;
      if (img.closest('[class*="thumb"]')) return;
      e.preventDefault();
      var src = img.currentSrc || img.src;
      try {
        var u = new URL(src, location.origin);
        u.searchParams.set('width', '1600');
        src = u.toString();
      } catch (err) { /* Original-URL behalten */ }
      gross.src = src;
      gross.alt = img.alt || '';
      dlg.showModal();
    });

    dlg.addEventListener('click', function (e) {
      if (e.target === dlg || e.target.id === 'zs-zoom-close') dlg.close();
    });
  })();

  /* --- M6: Beschreibung deckeln, nur mobil ------------------ */
  (function () {
    if (window.innerWidth > 1024) return;
    if (document.getElementById('zs-desc-btn')) return;

    var sec = null;
    var alle = document.querySelectorAll('[id*="shopify-section"]');
    for (var i = 0; i < alle.length; i++) {
      if (/big_description/.test(alle[i].id)) { sec = alle[i]; break; }
    }
    if (!sec) return;

    var inner = sec.querySelector('.container-fluid') || sec.querySelector('.rte') || sec.firstElementChild;
    if (!inner) return;
    if (inner.getBoundingClientRect().height < 1400) return;

    inner.classList.add('zs-desc-collapsed');
    var btn = document.createElement('button');
    btn.id = 'zs-desc-btn';
    btn.type = 'button';
    btn.textContent = zsText('more');
    inner.after(btn);

    btn.addEventListener('click', function () {
      var zu = inner.classList.toggle('zs-desc-collapsed');
      btn.textContent = zu ? zsText('more') : zsText('less');
      if (zu) inner.scrollIntoView({ block: 'start' });
    });
  })();
})();
/* PDP Kaufspalten-Accordions, 2026-08-08.
   Beschreibung, Details und Produkt-FAQ wandern als drei Accordions in die
   Kaufspalte neben der Galerie; die leeren Ursprungs-Sektionen und die
   Anker-Nav werden ausgeblendet. H2-Gruppen der Beschreibung ab 3 Stueck
   nachgefaltet (Gruppe 1 und 2 offen). Hebt den M6-Deckel auf. Greift eine
   Pruefung ins Leere (anderes Template, fehlende Sektion), rendert die Seite
   unveraendert. */
(function () {
  function zsFoldGroups(host) {
    var node = host;
    while (node.children.length === 1 && node.children[0].children.length) {
      node = node.children[0];
    }
    var kids = Array.prototype.slice.call(node.children);
    var h2Count = 0;
    kids.forEach(function (k) { if (k.tagName === 'H2') h2Count++; });
    if (h2Count < 3) return;
    var groups = [], cur = null;
    kids.forEach(function (k) {
      /* Metafeld-Box (one-product-box) nie in eine Untergruppe falten */
      if (k.classList && k.classList.contains('one-product-box')) {
        cur = null;
        return;
      }
      if (k.tagName === 'H2') {
        cur = { head: k, items: [] };
        groups.push(cur);
      } else if (cur) {
        cur.items.push(k);
      }
    });
    groups.forEach(function (g, i) {
      if (i < 2) return;
      var d = document.createElement('details');
      d.className = 'zs-acc zs-acc-nested';
      var s = document.createElement('summary');
      var body = document.createElement('div');
      body.className = 'zs-acc-body';
      node.insertBefore(d, g.head);
      s.appendChild(g.head);
      d.appendChild(s);
      g.items.forEach(function (it) { body.appendChild(it); });
      d.appendChild(body);
    });
  }

  function zsBuildColumnAccordions() {
    var infoCol = document.querySelector('.product-top .half.col-sm-6.product-details');
    if (!infoCol || document.getElementById('zs-pdp-acc')) return;
    var wrap = document.createElement('div');
    wrap.id = 'zs-pdp-acc';

    function acc(label, node) {
      var d = document.createElement('details');
      d.className = 'zs-acc zs-acc-top';
      var s = document.createElement('summary');
      s.textContent = label;
      var body = document.createElement('div');
      body.className = 'zs-acc-body';
      body.appendChild(node);
      d.appendChild(s);
      d.appendChild(body);
      wrap.appendChild(d);
    }

    var desc = document.querySelector('#product-description .split-title');
    if (desc) {
      zsFoldGroups(desc);
      acc(zsText('description'), desc);
    }
    var det = document.querySelector('#product-details #details-inner');
    if (det) acc(zsText('details'), det);

    /* FAQ: je Frage ein natives details (der Theme-jQuery-Toggle bindet an
       die Original-Sektion und feuert nach einem Move nicht mehr) */
    var faqItems = document.querySelectorAll('.product-faq .one-product-faq');
    if (faqItems.length) {
      var faqList = document.createElement('div');
      faqItems.forEach(function (item) {
        var qEl = item.querySelector('.one-product-question p');
        var aEl = item.querySelector('.one-product-answer');
        if (!qEl || !aEl) return;
        var d = document.createElement('details');
        d.className = 'zs-acc zs-acc-nested';
        var s = document.createElement('summary');
        s.textContent = qEl.textContent.trim();
        var body = document.createElement('div');
        body.className = 'zs-acc-body';
        body.appendChild(aEl);
        d.appendChild(s);
        d.appendChild(body);
        faqList.appendChild(d);
      });
      if (faqList.children.length) acc(zsText('faq'), faqList);
    }

    if (!wrap.children.length) return;
    infoCol.appendChild(wrap);

    /* Geleerte Sektionen + Anker-Nav ausblenden (Inhalt lebt jetzt in der Spalte) */
    var hide = [
      document.getElementById('product-description'),
      document.getElementById('product-details'),
      document.querySelector('.product-faq'),
      document.querySelector('.product-nav')
    ];
    hide.forEach(function (el) { if (el) el.style.display = 'none'; });

    /* M6-Deckel (Paket 05.08.) aufheben, falls aktiv */
    var descSec = document.getElementById('product-description');
    if (descSec) descSec.classList.remove('zs-desc-collapsed');
    var btn = document.getElementById('zs-desc-btn');
    if (btn) btn.remove();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', zsBuildColumnAccordions);
  } else {
    zsBuildColumnAccordions();
  }
})();
(function () {
  if (!document.body || !document.body.classList.contains('template-collection')) return;

  function headPadding() {
    var prod = document.getElementById('collection-products');
    var box = prod && prod.closest('.container-fluid');
    if (!prod || !box) return;
    var inner = box.getBoundingClientRect().right - parseFloat(getComputedStyle(box).paddingRight);
    var pr = Math.max(0, Math.round(inner - prod.getBoundingClientRect().right));
    document.documentElement.style.setProperty('--zs-head-pr', pr + 'px');
  }

  function apply() {
    var head = document.getElementById('collection-description');
    var row = document.getElementById('collections-main-row');
    if (!head || !row) return;
    if (head.parentElement !== row.parentElement) row.parentElement.insertBefore(head, row);
    headPadding();
    document.documentElement.classList.add('zs-coll-head');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }

  var timer;
  window.addEventListener('resize', function () {
    clearTimeout(timer);
    timer = setTimeout(headPadding, 120);
  });
}());
/* ===== Chat-Bubble raeumt die Sticky-Kaufleiste frei (2026-08-14) ===== */
(function () {
    var wrap = document.querySelector('.sticky-cart-wrapper');
    if (!wrap) return;
    var chat = null;

    function apply() {
        if (!chat) chat = document.querySelector('#flyweight-chat iframe');
        if (!chat) return;
        if (wrap.classList.contains('active')) {
            var h = wrap.getBoundingClientRect().height;
            chat.style.setProperty('bottom', (h + 16) + 'px', 'important');
        } else {
            chat.style.removeProperty('bottom');
        }
    }

    window.addEventListener('scroll', apply, { passive: true });
    window.addEventListener('resize', apply);
    apply();
})();
/* ===== Mobil-Menue Drilldown (2026-08-14) ===== */
(function () {
    var mm = document.getElementById('mobile-menu');
    if (!mm) return;

    mm.addEventListener('toggle', function (e) {
        var d = e.target;
        if (!d.open) return;
        var ul = d.parentElement && d.parentElement.parentElement;
        if (!ul) return;
        ul.querySelectorAll(':scope > li > details[open]').forEach(function (o) {
            if (o !== d) o.open = false;
        });
    }, true);

    document.addEventListener('click', function (e) {
        if (e.target.closest('#menu-open, #close-menu, .mobile-menu__overlay')) {
            mm.querySelectorAll('details[open]').forEach(function (d) { d.open = false; });
            return;
        }
        var s = e.target.closest('#mobile-menu summary.zsm-row');
        if (!s) return;
        for (var n = s.parentElement; n && n !== mm; n = n.parentElement) {
            if (n.scrollHeight > n.clientHeight) n.scrollTop = 0;
        }
    });

    var langSel = document.querySelector('#ZsmFooterLanguageForm select');
    if (langSel) {
        langSel.addEventListener('change', function () { langSel.form.submit(); });
    }
})();
/* Quick-Add auf Empfehlungen: add.js, dann Reload mit offenem Drawer (2026-09-14). */
document.addEventListener('submit', function (e) {
  var form = e.target;
  if (!form.matches('form[data-pcs-add]')) return;
  e.preventDefault();
  e.stopImmediatePropagation();
  if (form.dataset.zsAdding) return;
  form.dataset.zsAdding = '1';
  fetch(form.action.replace(/\/*$/, '.js'), { method: 'POST', body: new FormData(form), credentials: 'same-origin' })
    .then(function (r) { if (!r.ok) throw 0;
      document.cookie = 'show_cart=true; path=/; max-age=60';
      window.location.reload(); })
    .catch(function () { delete form.dataset.zsAdding; form.submit(); });
}, true);
/* Varianten-Preis-Reparatur, 2026-08-08.

   Bug in assets.js: es bindet an .one-variation-selection und schreibt den
   letzten <p> der geklickten Kachel in .current-price b:
       e = c(this).find("div:last-child").find("p:last-child").html();
       c(".current-price b").html(e);
   Bei Farb-Kacheln ist dieser <p> der Preis, bei Groessen-Kacheln die
   Groessenangabe. Folge: nach Klick auf eine Groesse steht "M: 52-60 cm" im
   Preisfeld statt des Preises, bis eine Farbe gewaehlt wird. Reiner
   Anzeigefehler, der Warenkorb bekommt die richtige Variante.

   Reparatur: Beobachter auf der Kaufzone. Steht im Preisfeld kein Preis, wird
   er aus der Varianten-ID (URL, sonst Formular) und den Produktdaten neu
   gesetzt. select[name="id"] taugt dafuer nicht, den setzt derselbe kaputte
   Handler auf leer. */
(function () {
  var wurzel = document.querySelector('.product-top');
  if (!wurzel || wurzel.dataset.zsPreisFix) return;
  wurzel.dataset.zsPreisFix = '1';

  var daten = null;
  var schreibt = false;

  function istPreis(text) {
    return /\d[\d.,]*\s*(€|EUR|CHF)|CHF\s*\d/.test(text);
  }

  function variantenId() {
    var ausUrl = new URLSearchParams(location.search).get('variant');
    if (ausUrl) return ausUrl;
    var form = document.querySelector('form.product-form, form[action*="/cart/add"]');
    if (!form) return null;
    return new FormData(form).get('id') || null;
  }

  function heile() {
    if (schreibt) return;
    var feld = wurzel.querySelector('.current-price');
    if (!feld || istPreis(feld.textContent)) return;
    var id = variantenId();
    if (!id) return;

    var schreib = function (produkt) {
      var v = produkt.variants.filter(function (x) { return String(x.id) === String(id); })[0];
      if (!v) return;
      schreibt = true;
      (feld.querySelector('b') || feld).textContent =
        window.Shopify && typeof Shopify.formatMoney === 'function' ? zsGeld(v.price) : (v.price / 100).toFixed(2).replace('.', ',') + ' €';
      setTimeout(function () { schreibt = false; }, 0);
    };

    if (daten) { schreib(daten); return; }
    fetch(location.pathname.split('?')[0] + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) { daten = p; schreib(p); })
      .catch(function () { /* ohne Produktdaten bleibt der Theme-Zustand stehen */ });
  }

  new MutationObserver(heile).observe(wurzel, { childList: true, subtree: true, characterData: true });
  heile();
})();
(function () {
  if (window.__zsStickyVariantSync) return;
  window.__zsStickyVariantSync = true;

  var wrapper = document.querySelector('.sticky-cart-wrapper');
  if (!wrapper) return;

  var form = wrapper.querySelector('form[action*="/cart/add"]');
  var variantSelects = wrapper.querySelector('.sticky-variant-selects');
  var variantJson = variantSelects && variantSelects.querySelector('script[type="application/json"]');
  var idInput = form && form.querySelector('input[name="id"]');
  var submitButton = form && form.querySelector('[type="submit"][name="add"]');

  if (!form || !variantSelects || !variantJson || !idInput || !submitButton) return;

  var variants;
  try {
    variants = JSON.parse(variantJson.textContent);
  } catch (error) {
    return;
  }

  if (!Array.isArray(variants) || !variants.length) return;

  var selects = Array.prototype.slice.call(variantSelects.querySelectorAll('select'));
  var addText = window.variantStrings && window.variantStrings.addToCart
    ? window.variantStrings.addToCart
    : submitButton.textContent.trim();
  var soldOutText = window.variantStrings && window.variantStrings.soldOut
    ? window.variantStrings.soldOut
    : 'Ausverkauft';
  var unavailableText = window.variantStrings && window.variantStrings.unavailable
    ? window.variantStrings.unavailable
    : soldOutText;
  var preOrderText = submitButton.getAttribute('data-pre-order') === 'true'
    ? submitButton.textContent.trim()
    : '';

  function money(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return zsGeld(cents);
    }

    var currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active
      ? window.Shopify.currency.active
      : 'EUR';

    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {
        style: 'currency',
        currency: currency
      }).format(cents / 100);
    } catch (error) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' €';
    }
  }

  function selectedOptions() {
    return selects.map(function (select) { return select.value; });
  }

  function findByOptions(options) {
    return variants.find(function (variant) {
      if (!Array.isArray(variant.options) || variant.options.length < options.length) return false;
      return options.every(function (value, index) {
        return variant.options[index] === value;
      });
    }) || null;
  }

  function findById(id) {
    return variants.find(function (variant) {
      return String(variant.id) === String(id);
    }) || null;
  }

  function updateUnitPrice(priceElement, variant) {
    var unitPrice = priceElement.querySelector('.unit-price');
    if (!unitPrice) return;

    var measurement = variant && variant.unit_price_measurement;
    if (!variant || !variant.unit_price || !measurement) {
      unitPrice.classList.add('hidden');
      return;
    }

    var spans = unitPrice.querySelectorAll('dd span');
    if (spans[0]) spans[0].textContent = money(variant.unit_price);
    if (spans[3]) {
      spans[3].textContent = (measurement.reference_value !== 1 ? measurement.reference_value + ' ' : '')
        + measurement.reference_unit;
    }
    unitPrice.classList.remove('hidden');
  }

  function updatePrices(variant) {
    if (!variant) return;

    wrapper.querySelectorAll('.price').forEach(function (priceElement) {
      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      var regularPrice = priceElement.querySelector('.price__regular .price-item--regular');
      var salePrice = priceElement.querySelector('.price__sale .price-item--sale');
      var comparePrice = priceElement.querySelector('.price__sale .price__compare .price-item--regular');

      priceElement.classList.toggle('price--on-sale', !!onSale);
      priceElement.classList.toggle('price--sold-out', !variant.available);

      if (regularPrice) regularPrice.textContent = money(variant.price);
      if (salePrice) salePrice.textContent = money(variant.price);
      if (comparePrice) comparePrice.textContent = onSale ? money(variant.compare_at_price) : '';

      updateUnitPrice(priceElement, variant);
    });
  }

  function updateForm(variant) {
    var available = !!(variant && variant.available);
    var idChanged = variant && idInput.value !== String(variant.id);

    if (variant) idInput.value = String(variant.id);
    idInput.disabled = !available;
    submitButton.disabled = !available;
    submitButton.style.removeProperty('display');
    submitButton.textContent = available
      ? (preOrderText || addText)
      : (variant ? soldOutText : unavailableText);

    if (variant) updatePrices(variant);

    if (idChanged) {
      idInput.dispatchEvent(new Event('input', { bubbles: true }));
      idInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function applyStickySelection() {
    var variant = findByOptions(selectedOptions());
    updateForm(variant);
    return variant;
  }

  function syncFromMain(id) {
    var variant = findById(id);
    if (!variant) return;

    selects.forEach(function (select, index) {
      if (variant.options[index] !== undefined) select.value = variant.options[index];
    });
    updateForm(variant);
  }

  selects.forEach(function (select) {
    select.addEventListener('change', applyStickySelection);
  });

  form.addEventListener('submit', applyStickySelection, true);

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || !target.matches('.top-right-product [name="id"][data-qb-bridge="1"]')) return;
    syncFromMain(target.value);
  });

  var mainId = document.querySelector('.top-right-product [name="id"][data-qb-bridge="1"]');
  if (mainId && mainId.value) {
    syncFromMain(mainId.value);
  } else {
    applyStickySelection();
  }
}());
document.addEventListener('click', function (e) {
  var link = e.target.closest('a[href*="#cookie-einstellungen" i]');
  if (!link) return;
  var host = document.querySelector('pandectes-cmp');
  var btn = host && host.shadowRoot && host.shadowRoot.querySelector('button.widget');
  if (!btn) return;
  e.preventDefault();
  btn.click();
});
/* ===== Sticky-Kaufleiste: sichtbarkeitsgekoppelt statt 1000px-Marke (2026-08-17) ===== */
(function () {
    var bar = document.querySelector('.sticky-cart-wrapper');
    if (!bar) return;
    var atc = document.querySelector('.product-top button[name="add"]');
    if (!atc) return;

    function sync() {
        var r = atc.getBoundingClientRect();
        var sichtbar = r.bottom > 0 && r.top < window.innerHeight;
        bar.classList.toggle('active', !sichtbar);
    }

    window.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
    window.dispatchEvent(new Event('scroll'));
})();
/* Drawer-Anzeige nach /cart/update.js: Server-Key in data-id und Feldname, Zeilenpreis und Streichpreis nachziehen, geloeschte Zeilen entfernen (2026-09-16 warenkorb-minimal). Mengen und Kasse laufen ohne JavaScript, das Formular traegt updates[key]. */
(function () {
  var drawer = document.getElementById('sliding-cart');
  if (!drawer || !window.jQuery || !window.Shopify || !Shopify.formatMoney) return;

  // Zuordnung erst über den Key, Rest über die Variante in DOM-Reihenfolge (Key wechselt bei Rabattwechsel).
  // Server-Zeilen ohne DOM-Zeile (App-Geschenke) bleiben unberührt.
  function pair(cart) {
    var rows = [].slice.call(drawer.querySelectorAll('.one-cart-item'));
    var used = {}, out = rows.map(function (row) { return { row: row, item: null }; });
    out.forEach(function (p) {
      var key = p.row.getAttribute('data-id') || '';
      for (var i = 0; i < cart.items.length; i++) {
        if (!used[i] && cart.items[i].key === key) { used[i] = true; p.item = cart.items[i]; return; }
      }
    });
    out.forEach(function (p) {
      if (p.item) return;
      var variant = String(p.row.getAttribute('data-id') || '').split(':')[0];
      // Abo und Einmalkauf derselben Variante nur bei gleichem Selling-Plan zuordnen (data-plan aus header.liquid; ohne Attribut nur Variante)
      var plan = p.row.getAttribute('data-plan');
      for (var i = 0; i < cart.items.length; i++) {
        if (used[i] || String(cart.items[i].variant_id) !== variant) continue;
        if (plan !== null && plan !== planOf(cart.items[i])) continue;
        used[i] = true; p.item = cart.items[i]; return;
      }
    });
    return out;
  }

  function planOf(li) {
    var a = li.selling_plan_allocation;
    return a && a.selling_plan ? String(a.selling_plan.id) : '';
  }

  function sync(cart) {
    pair(cart).forEach(function (p) {
      // Zeile ohne Server-Position ist geloescht (Antwort fuehrt sie nicht mehr): raus, sonst schickt ihr Feld updates[key]=0 und Shopify antwortet 422
      if (!p.item) { p.row.remove(); return; }
      var li = p.item;
      p.row.setAttribute('data-id', li.key);
      var input = p.row.querySelector('input');
      if (input) input.name = 'updates[' + li.key + ']';
      // Menge bewusst nicht nachziehen: eine aeltere Antwort darf keine neuere Wahl ueberschreiben (assets.js entprellt 400 ms)
      var lineDiscount = li.original_price > li.final_price;
      [].forEach.call(p.row.querySelectorAll('.cart-line-price'), function (el) {
        el.textContent = 0 === li.final_line_price ? zsText('gift') : zsGeld(li.final_line_price);
      });
      [].forEach.call(p.row.querySelectorAll('.cart-old-price'), function (el) {
        // data-unit-old aus dem Seitenaufbau gilt nur als Vergleichspreis, wenn er über dem Stückpreis liegt
        var compareAt = parseInt(el.getAttribute('data-unit-old'), 10) || 0;
        if (compareAt <= li.original_price) compareAt = 0;
        var unitOld = compareAt || (lineDiscount ? li.original_price : 0);
        el.textContent = unitOld > 0 ? zsGeld(unitOld * li.quantity) : '';
        el.style.display = unitOld > 0 ? '' : 'none';
        var cur = p.row.querySelector('.cart-current-price');
        if (cur) cur.classList.toggle('has-discount-price', unitOld > 0);
      });
    });
  }

  jQuery(document).ajaxSuccess(function (e, xhr, settings) {
    if (!/\/cart\/update\.js/.test((settings && settings.url) || '')) return;
    var cart = xhr.responseJSON;
    if (!cart || !cart.items) return;
    sync(cart);
    // Leerzustand wie der Theme-Handler r() in assets.js, der vor diesem Nachzug zaehlt
    document.body.classList.toggle('empty-cart', !drawer.querySelector('.one-cart-item'));
  });

  // Enter im Mengenfeld übernimmt die Menge (blur -> change), statt als implizite
  // Formularabgabe den Kasse-Button zu klicken
  drawer.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var input = e.target.closest('.one-cart-item input');
    if (!input) return;
    e.preventDefault();
    input.blur();
  });
})();
